import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { RotateCcw, Dices } from "lucide-react";

const FACE = ["", "⚀", "⚁", "⚂", "⚃", "⚄", "⚅"];
const WIN = 5;

export function DiceDuel() {
  const [you, setYou] = useState(0), [cpu, setCpu] = useState(0);
  const [yd, setYd] = useState(null), [cd, setCd] = useState(null);
  const [msg, setMsg] = useState("Roll the dice!");
  const [over, setOver] = useState(false);
  const [rolling, setRolling] = useState(false);

  const roll = () => {
    if (rolling || over) return;
    setRolling(true);
    setTimeout(() => {
      const a = Math.floor(Math.random() * 6) + 1, b = Math.floor(Math.random() * 6) + 1;
      setYd(a); setCd(b);
      let ny = you, nc = cpu;
      if (a > b) { ny++; setYou(ny); setMsg("You win the roll! 🎉"); }
      else if (b > a) { nc++; setCpu(nc); setMsg("CPU wins the roll!"); }
      else setMsg("Tie — roll again!");
      if (ny >= WIN) { setMsg("🏆 You won the match!"); setOver(true); }
      else if (nc >= WIN) { setMsg("💀 CPU won the match!"); setOver(true); }
      setRolling(false);
    }, 400);
  };

  const reset = () => { setYou(0); setCpu(0); setYd(null); setCd(null); setMsg("Roll the dice!"); setOver(false); };

  return (
    <div className="flex flex-col items-center text-center" data-testid="dice-duel">
      <div className="flex items-center justify-around w-full max-w-xs mb-6">
        <div><p className="text-xs uppercase text-neon-cyan font-bold">You</p><p className="font-display font-black text-4xl text-neon-cyan">{you}</p></div>
        <span className="font-display text-zinc-600">first to {WIN}</span>
        <div><p className="text-xs uppercase text-neon-pink font-bold">CPU</p><p className="font-display font-black text-4xl text-neon-pink">{cpu}</p></div>
      </div>
      <div className="flex items-center gap-8 mb-4 text-7xl">
        <span data-testid="dice-you" style={{ color: "#00F0FF" }}>{rolling ? "🎲" : FACE[yd] || "🎲"}</span>
        <span data-testid="dice-cpu" style={{ color: "#FF003C" }}>{rolling ? "🎲" : FACE[cd] || "🎲"}</span>
      </div>
      <p className="font-display font-bold text-lg mb-5 min-h-[28px]" data-testid="dice-msg">{msg}</p>
      {over ? (
        <Button onClick={reset} data-testid="dice-reset" className="bg-neon-cyan text-black rounded-none font-bold uppercase"><RotateCcw className="w-4 h-4 mr-1" /> Rematch</Button>
      ) : (
        <Button onClick={roll} data-testid="dice-roll" disabled={rolling} className="bg-neon-pink text-white rounded-none font-bold uppercase h-12 px-8"><Dices className="w-5 h-5 mr-2" /> Roll</Button>
      )}
    </div>
  );
}
